<div class="card" *ngIf="!loading">
  <div class="card-header">
    <strong>{{visuals?.requestForApprovalGridTitle}}</strong>
  </div>
  <div class="card-block p-0">
    <requestsForApproval></requestsForApproval>
  </div>
</div>
<form class="card card-accent-primary shadowed" *ngIf="!loading" (ngSubmit)="getStat()">
  <div class="card-header">
    <strong>{{visuals.selectDebtor}}</strong>
  </div>
  <div class="card-block">
    <div class="form-group">
      <div class="col-md-12 input-group">
        <input
          type="number"
          class="form-control"
          [(ngModel)]="debtorId"
          id="debtorId"
          name="debtorId"
        />
        <basesearchmodal
          [type]="'debtorModal'"
          (valueChange)="valueChanged('debtorModal',$event)"
        ></basesearchmodal>
      </div>
    </div>
  </div>
  <div class="card-footer">
    <button type="submit" class="btn btn-success" data-dismiss="modal">Search</button>
  </div>
</form>
<div *ngIf="!loading">
  <div class="card card-accent-primary shadowed">
    <div class="card-header">
      <strong>{{visuals.totalInv}}</strong>
    </div>
    <div class="card-block">
      <div class="row">
        <div class="col-md-2 text-center centering-things-vertical text-secondary">
          <span class="display-1 d-block font-medium">{{stats?.total}}</span>
          <h3 class="display-5 font-weight-bold">{{visuals.totalInv}}</h3>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-5 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)="navigateToResendInv()"
              [percent]="stats?.pendingInvPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-clock.png"
              [outerStrokeColor]="stats?.pendingInvPt == 0 ? '#e7e8ea' : '#D32F2F'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #D32F2F;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)="navigateToResendInv()"
                  >{{stats?.pendingInvPt}}% - ({{stats?.pendingInv}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.notReg}}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-5 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)='filterStatus("")'
              [percent]="stats?.registredInvPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-check.png"
              [outerStrokeColor]="stats?.registredInvPt == 0 ? '#e7e8ea' : '#4dbd74'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #4dbd74;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)='filterStatus("")'
                  >{{stats?.registredInvPt}}% - ({{stats?.registredInv}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.reg}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card card-accent-primary shadowed">
    <div class="card-header">
      <strong>{{visuals.regInv}}</strong>
    </div>
    <div class="card-block">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-2 offset-lg-1 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)='filterStatus("RG")'
              [percent]="statsStatus?.rgStatusPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-pending.png"
              [outerStrokeColor]="statsStatus?.rgStatusPt == 0 ? '#e7e8ea' :'#2c63ff'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #2c63ff;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)='filterStatus("RG")'
                  >{{statsStatus?.rgStatusPt}}% - ({{statsStatus?.rgStatusCount}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.pending}}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-2 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)='filterStatus("AUD")'
              startFromZero
              [percent]="statsStatus?.audStatusPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-edit.png"
              [outerStrokeColor]="statsStatus?.audStatusPt == 0 ? '#e7e8ea' : '#ffbc34'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #ffbc34;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)='filterStatus("AUD")'
                  >{{statsStatus?.audStatusPt}}% - ({{statsStatus?.audStatusCount}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.audit}}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-2 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)='filterStatus("ACC")'
              [percent]="statsStatus?.accStatusPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-check.png"
              [outerStrokeColor]="statsStatus?.accStatusPt == 0 ? '#e7e8ea' :'#4dbd74'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #4dbd74;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)='filterStatus("ACC")'
                  >{{statsStatus?.accStatusPt}}% - ({{statsStatus?.accStatusCount}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.accepted}}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-2 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)='filterStatus("RJ")'
              [percent]="statsStatus?.rjStatusPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-remove.png"
              [outerStrokeColor]="statsStatus?.rjStatusPt == 0 ? '#e7e8ea' :'#D32F2F'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #D32F2F;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)='filterStatus("RJ")'
                  >{{statsStatus?.rjStatusPt}}% - ({{statsStatus?.rjStatusCount}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.rejected}}</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-2 text-center centering-things-vertical">
          <div class="align-items-center">
            <circle-progress
              style="cursor: pointer;"
              (click)='filterStatus("RS")'
              [percent]="statsStatus?.rsStatusPt"
              [radius]="50"
              [outerStrokeWidth]="12"
              [innerStrokeWidth]="12"
              [backgroundPadding]="12"
              imageSrc="assets/img/account-remove.png"
              [outerStrokeColor]="statsStatus?.rsStatusPt == 0 ? '#e7e8ea' :'#D32F2F'"
              [innerStrokeColor]="'#e7e8ea'"
              [animation]="false"
              [showImage]="true"
              [showBackground]="false"
              [imageHeight]="42"
              [imageWidth]="42"
              [space]="-12"
            ></circle-progress>
            <div style="color: #D32F2F;">
              <h3 class="m-b-0">
                <span style="cursor: pointer;" (click)='filterStatus("RS")'
                  >{{statsStatus?.rsStatusPt}}% - ({{statsStatus?.rsStatusCount}})</span
                >
              </h3>
              <span class="font-weight-bold">{{visuals.rejectedBySupplier}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="dataLoader"></div>
